import { _, helpers, ts } from '_core';

import { DraftParams } from './types';
import { getBenchmarkTitle, getBucketsTitle } from '../../common/utils/get-name';

export const validate = (params: DraftParams) => {
  const rhErrors = helpers.validations.validSelectedReturnHorizon(params?.return_horizon);
  if (!_.isEmpty(rhErrors)) return rhErrors;
  if (!helpers.validations.validBuckets(params.buckets)) return ['Buckets are invalid.'];
  if (params.with_benchmark && !helpers.validations.validBenchmark(params.benchmark)) return ['Benchmark is invalid.'];
  return [];
};

export const getName = (
  params: DraftParams,
  _context: ts.types.signal.SignalAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  const init = getBucketsTitle(params.buckets, 'Equal-weighted Cumulative Return by Bucket', resources);
  if (params.benchmark) return getBenchmarkTitle(params.benchmark, init, resources.universes);
  return `${init} for ${helpers.returnHorizon.getLabel(params?.return_horizon)}`;
};
